import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadedDocumentSortHeader = ({
  label,
  columnKey,
  sortKey,
  sortDir,
  onSortColumn,
  className = '',
  align = 'left',
}) => {
  const active = sortKey === columnKey;
  const alignClass =
    align === 'right' ? 'justify-end w-full' : align === 'center' ? 'justify-center w-full' : '';

  return (
    <button
      type="button"
      onClick={() => onSortColumn(columnKey)}
      className={`inline-flex items-center gap-1.5 text-left text-xs font-semibold text-foreground font-caption uppercase tracking-wider hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded ${alignClass} ${className}`}
    >
      <span>{label}</span>
      {active ? (
        <Icon
          name={sortDir === 'asc' ? 'ArrowUp' : 'ArrowDown'}
          size={14}
          className="shrink-0 text-primary"
        />
      ) : null}
    </button>
  );
};

export default UploadedDocumentSortHeader;
